import Vue from '@vue/compat';

//require('@fortawesome/fontawesome-pro/js/all.js');
//require('./fontawesome.js');
require('@fortawesome/fontawesome-pro/js/all.js');
require('./fontawesome.js');

import ContractSubmit from './components/Contracts/Submit.vue';
import ContractsIndex from './components/Contracts/Index.vue';
import CustomerDetails from './components/Customer/Details.vue';
import DashUpload from "./components/User/DashUpload.vue";
import DataIndex from './components/DataIndex.vue';
import DeleteConfirmation from './components/DeleteConfirmation.vue';
import Dropdown from './components/Dropdown.vue';
import FileUpload from './components/Form/FileUpload.vue';
import Geography from './components/Geography/Geography.vue';
import ImageUpload from './components/Form/ImageUpload.vue';
import FarmsForm from './components/Farms/Form.vue';
import FarmsCreate from './components/Farms/Create.vue';
import FarmsSelector from './components/Farms/Selector.vue';
import FarmerDetails from './components/User/Details.vue'
import FieldsForm from './components/Fields/Form.vue';
import Home from './components/Home.vue';
import Help from './components/Help.vue';
import MapBox from './components/Geography/MapBox.vue';
import MapBoxHeatMap from './components/Geography/MapBoxHeatMap.vue';
import MapBoxSelect from "./components/Geography/MapBoxSelect.vue";
import Modal from './components/Modal.vue';
import Navigation from './components/Navigation.vue';
import NavTree from './components/NavTree.vue';
import NavigationItem from './components/NavigationItem.vue';
import Paginator from './components/Paginator.vue';
import RecruiterCodeInput from './components/RecruiterCodeInput.vue';
import RestoreConfirmation from './components/RestoreConfirmation.vue';
import ReEnrollmentPrompt from './components/ReEnrollmentPrompt.vue';
import StateSelector from "./components/StateSelector.vue";
import ApproveEstimate from "./components/Contracts/ApproveEstimate.vue";
import OverlapTerminal from "./components/OverlapTerminal.vue";
import PhoneNumberInput from "./components/PhoneNumberInput.vue";
import Portal from "./components/Admin/Portal.vue";
import Portfolio from "./components/Admin/Portfolio.vue";
import portfolioCustomerChart from "./components/Admin/portfolioCustomerChart.vue";
import portfolioAreaChart from "./components/Admin/portfolioAreaChart.vue";
import SelectWithInputOption from "./components/SelectWithInputOption.vue";
import EnrollmentHU from "./components/Farms/enrollmentHU.vue";
import sendRecruiterLink from "./components/User/sendRecruiterLink.vue";
import AgImport from "./components/AgImport.vue";
import DocusignEmbed from "./components/Contracts/DocusignEmbed.vue";
import Dashboard from "./components/Dashboard.vue";
import UserDashboard from "./components/User/UserDashboard.vue";
import Tile from "./components/Tile.vue";
import OperationsCarousel from "./components/User/OperationsCarousel";
import OperationsModal from "./components/User/OperationsModal";
import FileManager from "./components/User/FileManager.vue";
import Comments from "./components/Comments.vue";
import MassUpdater from "./components/MassUpdater.vue";
import FarmAddressAutofill from "./components/Farms/FarmAddressAutofill.vue";

/**
 * Create a fresh Vue application instance and attach it to the page
 */
window.app = Vue.createApp({
    el: '#app',
    compatConfig: {
        MODE: 2
    },
    data: function() {
        return {}

    },
    components: {}
});

import FloatingVue from 'floating-vue';

app.use(FloatingVue)

app.component('approve-estimate', ApproveEstimate)
app.component('contract-submit', ContractSubmit)
app.component('contracts-index', ContractsIndex)
app.component('customer-details', CustomerDetails);
app.component('portal', Portal);
app.component('dash-upload', DashUpload)
app.component('delete-confirmation', DeleteConfirmation);
app.component('dropdown', Dropdown);
app.component('farms-form', FarmsForm);
app.component('farms-create', FarmsCreate);
app.component('farm-selector', FarmsSelector);
app.component('farmer-details', FarmerDetails);
app.component('fields-form', FieldsForm);
app.component('file-upload', FileUpload);
app.component('geography', Geography);
app.component('help', Help);
app.component('home', Home);
app.component('image-upload', ImageUpload);
app.component('map-box', MapBox);
app.component('map-box-heat-map', MapBoxHeatMap);
app.component('map-box-select', MapBoxSelect);
app.component('modal', Modal);
app.component('navigation', Navigation);
app.component('nav-tree', NavTree);
app.component('navigation-item', NavigationItem);
app.component('overlap-terminal', OverlapTerminal)
app.component('paginator', Paginator);
app.component('phone-number', PhoneNumberInput);
app.component('portfolio', Portfolio);
app.component('portfolio-customer-chart', portfolioCustomerChart);
app.component('portfolio-area-chart', portfolioAreaChart);
app.component('recruiter-code', RecruiterCodeInput);
app.component('restore-confirmation', RestoreConfirmation);
app.component('re-enrollment-prompt', ReEnrollmentPrompt);
app.component('state-selector', StateSelector);
app.component('data-index', DataIndex);
app.component('select-with-input-option', SelectWithInputOption);
app.component('enrollment-hu', EnrollmentHU);
app.component('send-recruiter-link', sendRecruiterLink);
app.component('ag-import', AgImport);
app.component('docusign-embed', DocusignEmbed);
app.component('dashboard', Dashboard);
app.component('user-dashboard', UserDashboard);
app.component('tile', Tile);
app.component('operations-carousel', OperationsCarousel);
app.component('operations-modal', OperationsModal);
app.component('file-manager', FileManager);
app.component('comments', Comments);
app.component('mass-updater', MassUpdater);
app.component('farm-address-autofill', FarmAddressAutofill);

app.mount("#app");
